import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M0 9h5v4H0V9zm0 5h5v6H0v-6zm7-9h5v9H7V5zm7-5h5v7h-5V0zM7 15h5v5H7v-5zm7-7h5v12h-5V8z'],
  height: 20,
  width: 19,
});
